import React, { useState, useEffect } from "react";
import { FaPlusCircle, FaLock, FaWallet } from "react-icons/fa";
import { useSelector } from "react-redux";
import CardComponent from "../../../components/card";
import CardSkeleton from "../../../components/skeleton-loading/card";

const StudentDashboard = () => {
  const currentUser = useSelector((state) => state.auth.user);

  const [data, setData] = useState({
    slotsCount: 0,
    offersCount: 0,
    totalAmount: 0,
  });

  const [loading, setLoading] = useState(true);

  const fetchData = async () => {
    try {
      const [slotsRes, offersRes, totalAmountRes] = await Promise.all([
        fetch(
          `https://apis.tutify.online/students/${currentUser.id}/offers/slots/count`
        ),
        fetch(
          `https://apis.tutify.online/students/${currentUser.id}/offers/count`
        ),
        fetch(
          `https://apis.tutify.online/students/${currentUser.id}/transactions/totalAmount`
        ),
      ]);

      const [slotsData, offersData, totalAmountData] = await Promise.all([
        slotsRes.json(),
        offersRes.json(),
        totalAmountRes.json(),
      ]);

      setData({
        slotsCount: slotsData?.data?.offerSlotCount || 0,
        offersCount: offersData?.data?.offerCount || 0,
        totalAmount: totalAmountData?.data?.amount || 0,
      });
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (currentUser?.role === "student") {
      fetchData();
    }
    // eslint-disable-next-line
  }, [currentUser]);

  const stats = [
    {
      icon: <FaPlusCircle size={30} color="#1890ff" />,
      number: data.offersCount,
      label: "Offers",
    },
    {
      icon: <FaLock size={30} color="#722ed1" />,
      number: data.slotsCount,
      label: "Sessions",
    },
    {
      icon: <FaWallet size={30} color="#52c41a" />,
      number: `${Number(data.totalAmount)
        .toFixed(2)
        .toLocaleString("en-PK")} PKR`,
      label: "Paid amount",
    },
  ];

  return (
    <div>
      <h1 className="pageTitle">Student Offer Stats</h1>
      {!loading ? (
        <CardComponent data={stats} />
      ) : (
        <CardSkeleton loading={loading} boxes={3} />
      )}
    </div>
  );
};

export default StudentDashboard;
